import { jsx as _jsx } from "react/jsx-runtime";
import { javascript } from "@codemirror/lang-javascript";
import { abcdef } from "@uiw/codemirror-theme-abcdef";
import CodeMirror, { EditorView, lineNumbers } from "@uiw/react-codemirror";
import { useCallback, useMemo } from "react";
/**
 * Wrapper for Code-Mirror Editor.
 * Implemented to be compatible with AntD Forms.
 *
 * @see https://gist.github.com/ZhaoMuwei/b8321499d6283d84bb3b5ead1a206e46
 */ const CodeMirrorWrapper = ({ onChange, value, options, ...restProps })=>{
    const handleChange = useCallback((value)=>{
        onChange?.(value);
    }, [
        onChange
    ]);
    const extensions = useMemo(()=>{
        const exts = [];
        // Add line numbers if requested
        if (options?.lineNumbers !== false) {
            exts.push(lineNumbers());
        }
        // Add JavaScript language support if mode is javascript
        if (options?.mode === "javascript") {
            exts.push(javascript());
        }
        // Add line wrapping
        exts.push(EditorView.lineWrapping);
        return exts;
    }, [
        options?.lineNumbers,
        options?.mode
    ]);
    return /*#__PURE__*/ _jsx(CodeMirror, {
        value: value || "",
        onChange: handleChange,
        theme: abcdef,
        extensions: extensions,
        readOnly: options?.readOnly,
        ...restProps
    });
};
export { CodeMirrorWrapper };
